import { render, staticRenderFns } from "./InstantBooking.vue?vue&type=template&id=343e013a&scoped=true&"
import script from "./InstantBooking.vue?vue&type=script&lang=ts&"
export * from "./InstantBooking.vue?vue&type=script&lang=ts&"
import style0 from "./InstantBooking.vue?vue&type=style&index=0&id=343e013a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343e013a",
  null
  
)

export default component.exports